export default __webpack_public_path__ + "media/images/logo-small-e729cb5793b627ef66faad9db96579bb.png";